import { TRIAL_ELIGIBLE_TIERS, type Tier } from "@/lib/tier";

export type Billing = "monthly" | "yearly";
export type PaidTier = "starter" | "plus" | "pro" | "elite" | "agency";

export const TRIAL_SET = new Set<Tier>(TRIAL_ELIGIBLE_TIERS);
export const TIER_ORDER: PaidTier[] = ["starter", "plus", "pro", "elite", "agency"];

export const TIER_BLURBS: Record<PaidTier, string> = {
  starter: "For solo Knowledge Workers who wants one trusted home for their writing workflows.",
  plus: "For more active writers who need more connectors, MCPs, and a second workspace.",
  pro: "For publishers running up to 3 projects with full research-to-publish workflows.",
  elite: "For power users who want multi-workspace scale, BYOK AI keys, and team seats.",
  agency: "For studios running isolated client workspaces with BYOK, flexible add-ons and VAs.",
};

export const TIER_FEATURES: Record<PaidTier, string[]> = {
  starter: [
    "1 workspace",
    "Typed library with auto-fetched citations",
    "500 My Library sources (account total)",
    "125 excerpt image downloads/mo",
    "10 publishing connectors",
    "Excerptus AI + BYOK (optional)",
    "Image Studio with custom logo replacing the corner mark",
  ],
  plus: [
    "2 workspaces",
    "Everything in Starter, with higher caps",
    "1,500 My Library sources (account total)",
    "250 excerpt image downloads/mo",
    "20 publishing connectors",
    "MCP Inbound — Excerptus MCP server",
    "MCP Outbound — 10 external connections / workspace",
    "Excerptus AI + BYOK (optional)",
  ],
  pro: [
    "3 workspaces",
    "Everything in Plus",
    "4,500 My Library sources (account total)",
    "500 excerpt image downloads/mo",
    "30 publishing connectors",
    "MCP Inbound — Excerptus MCP server",
    "MCP Outbound — 10 external connections / workspace",
    "Multi-workspace coordination",
    "Excerptus AI + BYOK (optional)",
  ],
  elite: [
    "5 workspaces, plus 4 add-ons",
    "Everything in Pro",
    "1,000 My Library sources / workspace",
    "Unlimited publishing connectors",
    "MCP Inbound — Excerptus MCP server",
    "MCP Outbound — 10 external connections / workspace",
    "Per-workspace library isolation (opt-in)",
    "BYOK AI required",
  ],
  agency: [
    "10 workspaces + unlimited workspace add-ons",
    "Everything in Elite",
    "1,000 My Library sources / workspace",
    "Unlimited publishing connectors",
    "MCP Inbound — Excerptus MCP server",
    "MCP Outbound — 10 external connections / workspace",
    "Library isolation on by default per workspace",
    "Built for client studios",
    "BYOK AI required",
  ],
};


